import api from '@/api';
import { PageResult } from '@/core/request/PageResult';

import { API_BASE_URL } from '..';
import {
  CreateDirectSaleRequest,
  DirectSale,
  DirectSaleApplyTotalDiscountRequest,
  DirectSaleAuthorizationOrCancelation,
  DirectSaleStatisticsRequest,
  DirectSaleStatisticsResponse,
  DirectSaleUpdateTagRequest,
  ListDirectSaleQuery,
  UpdateDirectSaleRequest,
} from './DirectSale.types';

const CONTROLLER_URL = `${API_BASE_URL}/sales`;

export async function listDirectSale(
  params?: ListDirectSaleQuery,
): Promise<PageResult<DirectSale>> {
  const result = (await api.get(`${CONTROLLER_URL}`, {
    ...params,
    status: params?.status?.toString(),
  })) as unknown;

  return result as PageResult<DirectSale>;
}

export async function getDirectSale(id: number): Promise<DirectSale> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as DirectSale;
}

export async function createDirectSale(
  obj: CreateDirectSaleRequest,
): Promise<DirectSale> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as DirectSale;
}

export async function updateDirectSale(
  obj: UpdateDirectSaleRequest,
): Promise<DirectSale> {
  const result = (await api.put(
    `${CONTROLLER_URL}/${obj.id}`,
    obj,
    null,
  )) as unknown;

  return result as DirectSale;
}

export async function deleteDirectSale(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function authorizeDirectSale(
  obj: DirectSaleAuthorizationOrCancelation,
  saleId?: number,
): Promise<DirectSale> {
  const result = (await api.put(
    `${CONTROLLER_URL}/${saleId}/status`,
    obj,
    null,
  )) as unknown;

  return result as DirectSale;
}

export async function cancelDirectSale(
  obj: DirectSaleAuthorizationOrCancelation,
  saleId?: number,
): Promise<DirectSale> {
  const result = (await api.put(
    `${CONTROLLER_URL}/${saleId}/status`,
    obj,
    null,
  )) as unknown;

  return result as DirectSale;
}

export async function saleStatistics(params?: DirectSaleStatisticsRequest) {
  const result = (await api.get(
    `${CONTROLLER_URL}/saleStatistics`,
    params,
  )) as unknown;

  return result as DirectSaleStatisticsResponse;
}

export async function directSaleIncludeTag({
  saleId,
  ...params
}: DirectSaleUpdateTagRequest) {
  const result = (await api.patch(
    `${CONTROLLER_URL}/${saleId}/tag`,
    params,
    null,
  )) as unknown;

  return result;
}

export async function directSaleApplyTotalDiscount(
  params: DirectSaleApplyTotalDiscountRequest,
) {
  const result = (await api.put(
    `${CONTROLLER_URL}/apply-total-discount`,
    params,
    null,
  )) as unknown;

  return result as DirectSaleStatisticsResponse;
}
